/*
 * MANTRAROMA CUSTOM
 * Version: 1.0.0
 * Datum: 16.09.2026
 * Zweck: Consent-UI und Anbindung an die Shopify Customer Privacy API.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mantraroma-cookie-consent]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var version = root.dataset.version || '1.0.0';
  var preferencesPanel = root.querySelector('[data-mantraroma-cookie-preferences]');
  var mainActions = root.querySelector('[data-mantraroma-cookie-main-actions]');
  var saveActions = root.querySelector('[data-mantraroma-cookie-save-actions]');
  var status = root.querySelector('[data-mantraroma-cookie-status]');
  var customizeButton = root.querySelector('[data-consent-action="customize"]');
  var toggles = root.querySelectorAll('[data-consent-purpose]');
  var openerButtons = document.querySelectorAll('[data-mantraroma-cookie-settings]');

  function tinyCookieIsActive() {
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i].src.toLowerCase();
      if (src.indexOf('tinycookie') !== -1 || src.indexOf('tiny-cookie') !== -1) return true;
    }
    return Boolean(document.querySelector('[id*="tinycookie" i], [class*="tinycookie" i], [id*="tiny-cookie" i], [class*="tiny-cookie" i]'));
  }

  function setOpen(open) {
    root.hidden = !open;
    document.documentElement.classList.toggle('mantraroma-cookie-consent-open', open);
    if (open) {
      var firstButton = root.querySelector('button:not([hidden])');
      if (firstButton) firstButton.focus({ preventScroll: true });
    }
  }

  function showPreferences(show) {
    preferencesPanel.hidden = !show;
    mainActions.hidden = show;
    saveActions.hidden = !show;
    customizeButton.setAttribute('aria-expanded', show ? 'true' : 'false');
  }

  function setStatus(message, isError) {
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function auditConsent(consent) {
    try {
      localStorage.setItem('mantraroma_consent', JSON.stringify({
        version: version,
        timestamp: new Date().toISOString(),
        preferences: Boolean(consent.preferences),
        analytics: Boolean(consent.analytics),
        marketing: Boolean(consent.marketing)
      }));
    } catch (error) {
      // Die Shopify-Einwilligung bleibt auch ohne lokalen Zusatznachweis gültig.
    }
  }

  function readCurrentConsent(api) {
    var current = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
    return {
      preferences: current.preferences === 'yes',
      analytics: current.analytics === 'yes',
      marketing: current.marketing === 'yes',
      isEmpty: !current.preferences && !current.analytics && !current.marketing
    };
  }

  function syncToggles(consent) {
    for (var i = 0; i < toggles.length; i += 1) {
      toggles[i].checked = Boolean(consent[toggles[i].dataset.consentPurpose]);
    }
  }

  function selectedConsent() {
    var consent = { preferences: false, analytics: false, marketing: false };
    for (var i = 0; i < toggles.length; i += 1) {
      consent[toggles[i].dataset.consentPurpose] = toggles[i].checked;
    }
    return consent;
  }

  function applyConsent(api, consent) {
    setStatus('Auswahl wird gespeichert …', false);
    root.classList.add('is-saving');
    api.setTrackingConsent(consent, function () {
      root.classList.remove('is-saving');
      auditConsent(consent);
      setStatus('', false);
      setOpen(false);
      showPreferences(false);
      document.dispatchEvent(new CustomEvent('mantraroma:consent-updated', { detail: consent }));
    });
  }

  function connect(api) {
    var current = readCurrentConsent(api);
    syncToggles(current);

    for (var i = 0; i < openerButtons.length; i += 1) {
      openerButtons[i].hidden = false;
      openerButtons[i].addEventListener('click', function () {
        syncToggles(readCurrentConsent(api));
        showPreferences(true);
        setOpen(true);
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-consent-action]');
      if (!button || root.classList.contains('is-saving')) return;
      var action = button.dataset.consentAction;

      if (action === 'necessary') applyConsent(api, { preferences: false, analytics: false, marketing: false });
      if (action === 'all') applyConsent(api, { preferences: true, analytics: true, marketing: true });
      if (action === 'customize') showPreferences(true);
      if (action === 'back') showPreferences(false);
      if (action === 'save') applyConsent(api, selectedConsent());
    });

    // Die Auswahl wird bei einem neuen Besucher immer aktiv eingeholt.
    // So bleibt der Banner unabhängig von einer eventuell deaktivierten
    // Shopify-Standardanzeige funktionsfähig.
    if (current.isEmpty) setOpen(true);
  }

  function initialize() {
    if (tinyCookieIsActive()) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      setStatus('Die Datenschutzeinstellungen konnten nicht geladen werden. Bitte lade die Seite neu.', true);
      setOpen(true);
      return;
    }

    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function (error) {
      if (error || !window.Shopify.customerPrivacy) {
        setStatus('Die Datenschutzeinstellungen konnten nicht geladen werden. Bitte lade die Seite neu.', true);
        setOpen(true);
        return;
      }
      connect(window.Shopify.customerPrivacy);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
}());
